// extracted by mini-css-extract-plugin
export default {"icon":"ButtonDelete-modules__icon__zUvbo","show-keyframe":"ButtonDelete-modules__show-keyframe__sgXkO"};